import React, { useEffect, useState } from 'react'

import './generatedReport.css'
import { request, api } from '../../../util/handlerRequestUtil'
import ReportGeneralAction from './ReportGeneralAction'

const GeneratedReport = function () {
  const [data, setData] = useState({})

  useEffect(() => {
    loadData()
  }, [])

  async function loadData() {
    const filters = window.location.search
    const responseReport = await request(api.getActionsReport(filters))
    setData(responseReport)
  }

  function hasValidDynamicFields(reportProps, validTypeIds) {
    const dynamicFields = []
    const imgs = []
    if (Array.isArray(reportProps.dynamicFields)) {
      reportProps.dynamicFields.forEach((item) => {
        if (validTypeIds.includes(item.fieldTypes.id) && item.answer !== null) {
          if (item.fieldTypes.id === '7') {
            const fileInfo = JSON.parse(item.answer)
            if (Array.isArray(fileInfo)) {
              for (const image of fileInfo) {
                if (
                  (image.apiResponse !== null &&
                    image.apiResponse.fileUri !== null &&
                    image.apiResponse.fileType !== null &&
                    image.apiResponse.fileType.includes('image')) ||
                  (image.file !== null &&
                    image.file.fileUri !== null &&
                    image.file.fileType !== null &&
                    image.file.fileType.includes('image'))
                ) {
                  imgs.push(image)
                }
              }

              dynamicFields.push(item)
            }
          } else {
            dynamicFields.push(item)
          }
        }
      })
    }

    return { dynamicFields, imgs }
  }

  function separar(itens, maximo) {
    return itens.reduce((acumulador, item, indice) => {
      const grupo = Math.floor(indice / maximo)
      acumulador[grupo] = [...(acumulador[grupo] || []), item]
      return acumulador
    }, [])
  }

  function renderPages(posibleTypes, report, page, max) {
    const { dynamicFields } = hasValidDynamicFields(report, posibleTypes)
    if (Array.isArray(dynamicFields) && dynamicFields.length > 0) {
      const lists = separar(dynamicFields, max)
      const pages = []
      for (const list of lists) {
        pages.push(
          <div className="page">
            <ReportGeneralAction page={page} reportProps={report} dynamic={list} />
          </div>
        )
      }

      return pages
    }
  }

  if (Array.isArray(data)) {
    if (data.length > 0) {
      return (
        <div className="book">
          {data.map((report) => {
            return (
              <>
                {renderPages(['1', '2', '4'], report, 1, 10)}
                {renderPages(['7'], report, 2, 1)}
              </>
            )
          })}
        </div>
      )
    }

    return 'não foram encontrados resultados =('
  }

  return <>loading...</>
}

export default GeneratedReport
